import { motion, useTransform, useViewportScroll } from 'framer-motion';
import React from 'react';
import styled from 'styled-components';
import { device } from '../../styles/devices';
import { gutter } from '../../styles/mixins';
import { theme } from '../../styles/theme';
import { p16 } from '../../styles/typography';
import useMediaQuery from '../../utils/use-media-query';
import { LazyShow } from '../reveal/reveal';

const Host = styled(motion.div)`
  max-width: 683px;
  margin: 90px auto;

  @media ${device.tablet} {
    margin: 100px auto;
  }

  @media ${device.desktop} {
    margin: 180px auto;
  }
  ${p16};

  b,
  strong {
    font-weight: 500;
  }

  i,
  em {
    font-style: italic;
  }

  p {
    margin-bottom: ${gutter(6)};

    &:last-child {
      margin-bottom: 0;
    }
  }
  a {
    color: ${theme.colors.navy100};
    text-decoration: underline;
  }
`;

interface CopyProps {
  children: React.ReactNode;
  speed?: number;
}

export const Copy = ({ children, speed = 1 }: CopyProps) => {
  const { scrollYProgress } = useViewportScroll();
  const isDesktop = useMediaQuery(
    `(min-width: ${theme.breakpoints.md.width}px)`
  );

  const yValue = useTransform(
    scrollYProgress,
    [0, 0.5, 1],
    [0, 50, 100 * speed]
  );
  return (
    <Host
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      style={{ y: isDesktop ? yValue : 0 }}
    >
      <LazyShow>{children}</LazyShow>
    </Host>
  );
};
